<template>    
    <div class="card card-custom">

        <div class="card-body pb-20">
            <div class="row">
                <div class="col">
                    <div class="row justify-content-center">
                        <h1 class="font-weight-bolder text-center display-3">¿Qué te gustaría ver?</h1>
                    </div>
                    <div class="row justify-content-center mb-5"><span class="text-inicio text-center">Elige la opción que mejor se adapte a tus requerimientos</span></div>

                        <div class="row justify-content-center row-custom">
                            
                            <router-link class="card-custom border rounded mx-3 my-4 p-6 mw350 shadow-lg card-hover" to="/athlete">
                                <div class="row justify-content-between m-0 align-items-center">
                                    <div class="p-0 col">
                                        <img :src="'./media/logos/athleteo.png'" class="imghome"  alt="">
                                    </div>
                                    <div class="p-0 col"><span class="title-right h1">Eventos Internacionales</span></div>
                                </div>
                            </router-link>

                            <router-link class="card-custom border rounded mx-3 my-4 p-6 mw350 shadow-lg card-hover" to="/nacionales">
                                <div class="row justify-content-between m-0 align-items-center">
                                    <div class="p-0 col">
                                        <img :src="'./media/logos/athleteo.png'" class="imghome"  alt="">
                                    </div>
                                    <div class="p-0 col"><span class="title-right h1">Eventos Nacionales</span></div>
                                </div>
                            </router-link>

                            <router-link class="card-custom border rounded mx-3 my-4 p-6 mw350 shadow-lg card-hover" to="/official">
                                <div class="row justify-content-between m-0 align-items-center">
                                    <div class="p-0 col">
                                        <img :src="'./media/logos/officers.png'" class="imghome"  alt="">
                                    </div>
                                    <div class="p-0 col"><span class="title-right h1">Acreditar Oficiales</span></div>
                                </div>
                            </router-link>

                            <router-link class="card-custom border rounded mx-3 my-4 px-6 mw350 shadow-lg card-hover"  to="/credentials">
                                <div class="row justify-content-between m-0 align-items-center">
                                    <div class="p-0 col">
                                        <img :src="'./media/logos/credential.png'" class="imghome"  alt="">
                                    </div>
                                    <div class="p-0 col"><span class="title-right h1">Descargar Credenciales</span></div>
                                </div>
                            </router-link>

                            <router-link class="card-custom border rounded mx-3 my-4 py-6 px-6 mw350 shadow-lg card-hover"  to="/athlete-history">
                                <div class="row justify-content-between m-0 align-items-center">
                                    <div class="p-0 col">
                                        <img :src="'./media/logos/history.png'" class="imghome"  alt="">
                                    </div>
                                    <div class="p-0 col"><span class="title-right h1">Historial participación</span></div>
                                </div>
                            </router-link>

                        </div>

                        <div class="row justify-content-center row-custom">
                            
                            <div class="card-custom border rounded mx-3 my-4 p-8 mw350 shadow-lg d-none">
                                <div class="row justify-content-between m-0 align-items-center">
                                    <div class="p-0 col">
                                        <img :src="'./media/logos/timeline2.png'" class="imghome"  alt="">
                                    </div>
                                    <div class="p-0 col"><span class="title-right h1">Mi Participación</span></div>
                                </div>
                            </div>

                            
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: 'dashboard',
    components: {},
    computed: {
        ...mapGetters(['layoutConfig']),
    },
    created(){
        let bgImage = this.layoutConfig("self.body.background-image")
        document.body.style.backgroundImage = `url(${bgImage})`;
    }
}
</script>
<style>
.imghome{ height: 120px; margin-right: 2px;}
.mw350{ max-width: 380px;}

</style>